import React from 'react'

const InputTextComp = React.forwardRef(({
    label,
    name,
    value,
    type,
    error,
    className,
    onChange,
    hoverMessage,
    minLength,
    maxLength,
    max,
    required,
    ...rest
},
    ref
) => (
    <div className="row mb-1" title={hoverMessage}>
        <label htmlFor={name} className={"col-auto col-form-label"}>
            {label}
        </label>
        <div className="col-auto">
            <input
                type={type}
                className={`form-control text dark input-audit-focus ${className}`}
                name={name}
                value={value}
                onChange={onChange}
                ref={ref}
                {...rest}
                required={required}
                maxLength={maxLength}
                max={max}
                minLength={minLength}
                style={{ height: '2.375rem' }}
                title={value}
            />
        </div>
        {error && <p className="text-danger mt-2">{error.message}</p>}
    </div>
));


export default InputTextComp